import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import {Provider} from 'react-redux';
import thunk from 'redux-thunk';
import {BrowserRouter} from 'react-router-dom';
import createSagasMiddleware from 'redux-saga';

import App from './App/index';
import * as serviceWorker from './serviceWorker';
import reducer from './store/reducer';
import sagas from './store/sagas';
import config from './config';
import { toast } from 'react-toastify';
toast.configure({ autoClose: 3000 })

const sagasMiddleware = createSagasMiddleware();


const store = createStore(reducer, applyMiddleware(sagasMiddleware, thunk));
sagasMiddleware.run(sagas);

const app = (
  <Provider store={store}>
      <BrowserRouter basename={config.basename}>
        <App />
      </BrowserRouter>
  </Provider>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
